export default "__VITE_ASSET__CuIxyMrc__"